export default {
  navigation: {
    directory: "Annuaire Artisans RGE",
    ambassadors: "Ambassadeurs",
    careers: "Carrières",
    blog: "Blogs",
    about: "Nous connaître",
    product: "Produit",
    technology: "Technologie",
    menu: "Menu",
  },
  home: {
    title: "Envie de faire quelque chose grand ?",
    description:
      "Rejoignez nous et aidez n’importe qui, n’importe où à passer au solaire et accéder à une énergie propre et illimitée.",
    mission: {
      label: "Opportunités chez Projet Solaire",
      title: "Notre mission",
    },
  },
  values: {
    title: "Ce que nous recherchons",
    description:
      "Nous sommes une communauté d'engagement ou chacun partage et cultive l'audace, la perséverance et l'empathie dans notre petite équipe.",
    value1: {
      title: "Soyez les meilleurs",
      description:
        "Aspirez à l'excellence et atteignez des nouveaux sommets. Surmontez les défis avec détermination. Utilisez vos talents et recherchez la croissance. Incarnez le succès et l'amélioration continue.",
    },
    value2: {
      title: "Partagez tout ce que vous savez",
      description:
        "Adoptez l'échange de connaissances et la collaboration. Partagez votre expertise et vos idées. Créez un monde de connaissances accessibles. Cultivez la curiosité.",
    },
    value3: {
      title: "Toujours en apprentissage",
      description:
        "Soyez autodidacte ! Recherchez de nouvelles expériences. Envisagez les échecs comme des leçons. Adaptez-vous aux changements. Apprenez, grandissez et prospérez.",
    },
    value4: {
      title: "Soyez solidaire",
      description:
        "Créez un environnement bienveillant. Célébrez les réussites. Offrez votre aide. Favorisez l'empathie et les liens. Construisez la prospérité collective.",
    },
    value5: {
      title: "Assumez vos responsabilités",
      description:
        "Acceptez l'obligation de rendre des comptes. Assumez vos actes. Apprenez de vos erreurs. Reconnaissez l'impact de vos actions.",
    },
    value6: {
      title: "Vivez votre meilleure vie",
      description:
        "Reconnaissez l'importance du repos. Détendez-vous et rechargez vos batteries. Engagez-vous dans des activités joyeuses. Trouvez l'équilibre.",
    },
  },
  stats: {
    title: "Accélerer la révolution <br /> solaire",
    description:
      "Notre plateforme communautaire connecte les individus passant au solaire avec des professionnels de l’installation photovoltaïque.",
    stat1: {
      value: "+122 MW",
      label: "de chantiers solaires",
    },
    stat2: {
      value: "+8000",
      label: "chantiers solaires",
    },
    stat3: {
      value: "+1000",
      label: "professionnels",
    },
  },
  coreValues: {
    value1: {
      title: "Le client avant tout",
      description:
        "L'excellence opérationnelle de nos équipes au meilleur prix pour nos clients est non-négociable.",
    },
    value2: {
      title: "Répidité",
      description:
        "Nous expédions les articles rapidement. Nous répondons immédiatement. Nous agissons vite.",
    },
    value3: {
      title: "Travail d'équipe",
      description:
        "Nous sommes une petite équipe de superstars. On accomplit tout ensemble. Notre recette magique : pragmatisme et gentillesse.",
    },
  },
  quote: {
    text: "Ils peuvent, parce qu’ils pensent qu’ils peuvent.",
    attribution: "Virgile - Eneïde, livre 5",
  },
  growth: {
    title: "Notre projetsolaire grandit.<br /> Grandissez avec nous.",
    description:
      "Implantée en Provence, nous sommes à la recherche de talents à faire fleurir et prospérer. Envie d'avoir un impact sur le climat en aidant nos concitoyens à faire la revolution solaire ? Bienvenue !",
    button: "Voir les postes vacants",
  },
  commitments: {
    FULL_TIME: "Temps plein",
    PART_TIME: "Temps partiel",
    INTERNSHIP: "Stage",
    CONTRACT: "Auto-entrepreneur",
    COFOUNDER: "Directeur·ice",
  },

  roles: {
    COFOUNDER: "Directeur·ice",
    PROGRAMMING: "Développeur·euse",
    CONTRACT: "Prestataire",
    DESIGN: "Designeur·euse",
    MANAGEMENT: "Rôles stratégiques",
    BUSINESS_DEVELOPMENT: "Développeur·euse d'affaires",
    SALES_AND_MARKETING: "Commercial·e",
    ADMINISTRATION: "Administratif",
    OPERATIONS: "Opérations",
    SERVICE_CLIENT: "Service client",
  },
  roleDescriptions: {
    COFOUNDER:
      "Vous participez à la définition de la vision, de la stratégie et de la culture de l'entreprise. En tant que directeur·ice ou cofondateur·ice, vous jouez un rôle clé dans la croissance et l'orientation globale de nos activités.",

    PROGRAMMING:
      "Vous contribuez au développement de nos produits en écrivant du code propre, maintenable et performant. Vous travaillez en étroite collaboration avec les équipes produit et design pour donner vie à nos idées.",

    CONTRACT:
      "En tant que prestataire externe, vous intervenez sur des missions ponctuelles ou spécifiques. Vous apportez votre expertise pour renforcer nos équipes et soutenir nos projets selon vos disponibilités.",

    DESIGN:
      "Vous imaginez et concevez des expériences utilisateur à la fois intuitives et esthétiques. Vous êtes garant·e de la cohérence visuelle de nos produits et collaborez avec les développeur·euses et les responsables produit.",

    MANAGEMENT:
      "Vous encadrez et accompagnez les équipes pour atteindre leurs objectifs. En tant que gérant·e, vous assurez la coordination, le suivi des performances et la mise en œuvre des stratégies opérationnelles.",

    BUSINESS_DEVELOPMENT:
      "Vous identifiez de nouvelles opportunités de croissance, développez des partenariats et contribuez à l’expansion stratégique de l’entreprise sur ses marchés cibles.",

    SALES_AND_MARKETING:
      "Vous êtes en charge de promouvoir nos offres, attirer de nouveaux clients et fidéliser les existants. Vous combinez créativité et analyse pour concevoir des campagnes percutantes.",

    ADMINISTRATION:
      "Vous assurez le bon fonctionnement administratif de l'entreprise (RH, finance, gestion quotidienne). Votre rôle est essentiel au soutien des équipes et à la fluidité des opérations internes.",

    OPERATIONS:
      "Vous veillez à l’efficacité et à l’optimisation des processus internes. Vous coordonnez les ressources, les outils et les équipes pour garantir des résultats de qualité au quotidien.",

    SERVICE_CLIENT:
      "Vous êtes le point de contact principal de nos utilisateur·ices. Vous apportez écoute, réactivité et solutions pour garantir une expérience client irréprochable.",
  },

  testimonials: {
    title: "Ce que nos collaborateurs disent",
    description:
      "Découvrez les témoignages de nos employés sur leur parcours et fierté.",
    quote:
      "Travailler ici m’a permis de grandir professionnellement tout en contribuant à un projet qui a du sens.",
    name: "Marie Dupont",
    role: "Chargée de projet",
  },
  jobs: [
    {
      title: "Chargé(e) d'intégration des comptes",
      description:
        "De plus en plus de professionnels veulent nos solutions. Aidez-nous à soutenir les installateurs photovoltaïques et stockage.",
      type: "Auto-entrepreneur",
      role: "Commercial(e)",
      location: "Marseille, France",
    },
    {
      title: "Responsable Service client",
      description:
        "Nous sommes à la recherche d'une personne extrêmement talentueuse et efficace pour soutenir nos efforts de croissance en France.",
      type: "Temps plein",
      role: "Développeur(euse) d'affaires",
      location: "Marseille, France",
    },
  ],
  openings: {
    "view-all-openings": "Voir tous les postes vacants",
  },
  post2: {
    intro: {
      label: "Carrières chez projetsolaire",
      title: {
        colored: "Rejoignez-nous",
        rest: " pour avoir un impact sur l'énergie solaire.",
      },
      description:
        "Nous construisons l'avenir d'une énergie propre et décentralisée dans le sud de la France, au cœur de paysages parmi les plus beaux du monde.",
    },
    opportunities: {
      title: "Notre projetsolaire grandit. Grandissez avec nous.",
      description:
        "Implantée en Provence, nous sommes à la recherche de talents à faire fleurir et prospérer. Envie d'avoir un impact sur le climat en aidant nos concitoyens à faire la revolution solaire ? Bienvenue !",
    },
    operation: {
      title: "Opérations",
      description: "Postes à pourvoir au sein de notre département opérations",
      job: {
        title: "Chargé(e) d'intégration des comptes",
        description:
          "De plus en plus de professionnels veulent nos solutions. Aidez-nous à soutenir les installateurs photovoltaïques et stockage.",
        type: "Auto-entrepreneur",
        role: "Commercial(e)",
        location: "Marseille, France",
      },
    },
    service: {
      title: "Service client",
      description:
        "Postes à pourvoir au sein de notre département service client",
      job: {
        title: "Responsable Service client",
        description:
          "Nous sommes à la recherche d'une personne extrêmement talentueuse et efficace pour soutenir nos efforts de croissance en France.",
        type: "Temps plein",
        role: "Développeur(euse) d'affaires",
        location: "Marseille, France",
      },
    },
    apply: "Candidater",
    closed: "Fermé",
    tabs: {
      all: "Tous",
      open: "Ouverts",
      reviewing: "En revue",
    },
    "no-jobs": {
      title: "Aucune opportunité d'emploi disponible",
      description:
        "Nous n'avons pas de postes ouverts pour le moment. Revenez plus tard pour de nouvelles opportunités !",
    },
  },
  apply: {
    question: "Avez-vous ce qu'il faut pour réussir?",
    button: "Candidater aujourd'hui",
    share: "Partager:",
    // New translations for Apply.vue component
    form: {
      breadcrumb: {
        careers: "Carrières",
      },
      title: "Envoyer votre candidature",
      description:
        "Parlez-nous de vous ! Complétez le formulaire ci-dessous pour soumettre votre candidature.",
      profile: {
        title: "Votre profil",
      },
      fields: {
        firstName: "First name / Prénom",
        lastName: "Last name / Nom",
        email: "Email / Adresse mail",
        phone: "Phone number / Téléphone",
        about: "Parlez-nous de vous",
        cv: "Resume / CV",
        motivationLetter: "Motivation letter / Lettre de motivation",
      },
      upload: {
        uploadFile: "Télécharger fichier",
        dragDrop: "ou glisser-déposer",
        fileFormat: "PDF jusqu'à 10MB",
        uploadFileText: "Télécharger fichier",
      },
      submit: "Envoyer candidature",
      processing: "Traitement en cours",
    },
  },
}
